import { render, staticRenderFns } from "./ai_assistant.vue?vue&type=template&id=0d88834f&scoped=true&"
import script from "./ai_assistant.vue?vue&type=script&lang=js&"
export * from "./ai_assistant.vue?vue&type=script&lang=js&"
import style0 from "./ai_assistant.vue?vue&type=style&index=0&id=0d88834f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d88834f",
  null
  
)

export default component.exports